import styled from '@emotion/styled';
import { icons } from '@ublend-npm/aulaui-next';

import { breakpoints } from '../GlobalStyle/GlobalStyle.styles';

export const AppStoreLink = styled.a`
  display: inline-block;
  overflow: hidden;
  border-radius: 7px;
  width: 120px;
  height: 40px;

  @media (min-width: ${breakpoints.large}) {
    margin-left: var(--spacing-small);
  }
`;

export const AppStoreImage = styled(icons.AppStoreLogo)`
  border-radius: 7px;
  width: 120px;
  height: 40px;
`;

export const PlayStoreLink = styled.a`
  display: inline-block;
  overflow: hidden;
  width: 135px;
  height: 40px;
  border-radius: 5px;
`;

export const PlayStoreImage = styled(icons.PlayStoreLogo)`
  width: 135px;
  height: 40px;
  border-radius: 5px;
`;
